import { Link } from 'react-router-dom';

const CHALLENGES = [
  {
    type: 'multiplication',
    title: 'Multiplication',
    icon: 'ri-close-line',
    color: 'from-green-800 to-green-600',
    tag: 'bg-lime-400 text-green-900',
    desc: 'Smash through multiplication problems from single-digit basics to expert word problems. Train your speed and accuracy.',
    levels: ['Easy: 2-5 × 2-10', 'Medium: 6-12 × 6-12', 'Hard: 13-20 × 13-20', 'Expert: Word problems'],
    path: '/multiplication-challenge',
    image: 'https://public.readdy.ai/ai/img_res/b842f1693ad590373286155f63479b88.jpg',
  },
  {
    type: 'volume',
    title: 'Volume',
    icon: 'ri-box-3-line',
    color: 'from-teal-800 to-teal-600',
    tag: 'bg-teal-400 text-teal-900',
    desc: 'Calculate volumes of 3D shapes — from simple rectangular prisms to spheres, cones, and complex composite figures.',
    levels: ['Easy: Rectangular prisms', 'Medium: Cylinders', 'Hard: Cones & spheres', 'Expert: Composite shapes'],
    path: '/volume-challenge',
    image: 'https://readdy.ai/api/search-image?query=geometric%203D%20shapes%20like%20cube%2C%20cylinder%2C%20sphere%20and%20cone%20floating%20above%20a%20tennis%20court%20with%20clean%20studio%20lighting%2C%20mathematical%20geometry%20visualization%2C%20white%20background%20elements%2C%20vibrant%20colors%2C%20professional%20product%20photography&width=600&height=400&seq=feat-vol-1&orientation=landscape',
  },
  {
    type: 'division',
    title: 'Division',
    icon: 'ri-divide-line',
    color: 'from-emerald-800 to-emerald-600',
    tag: 'bg-emerald-400 text-emerald-900',
    desc: 'Ace division challenges ranging from simple exact division to complex decimal calculations and tennis-themed word problems.',
    levels: ['Easy: Exact division', 'Medium: With remainders', 'Hard: Decimal results', 'Expert: Word problems'],
    path: '/division-challenge',
    image: 'https://readdy.ai/api/search-image?query=tennis%20player%20serving%20with%20division%20symbols%20and%20numbers%20floating%20around%20in%20a%20dramatic%20overhead%20shot%2C%20sports%20photography%2C%20mathematical%20theme%2C%20vivid%20green%20court%2C%20dynamic%20action%20frozen%20in%20time%2C%20professional%20photography&width=600&height=400&seq=feat-div-1&orientation=landscape',
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="text-xs font-bold uppercase tracking-widest text-green-600 bg-green-100 px-3 py-1 rounded-full">
            Challenge Types
          </span>
          <h2
            className="text-4xl font-bold text-green-900 mt-3"
            style={{ fontFamily: "'Bebas Neue', sans-serif", letterSpacing: '0.04em' }}
          >
            PICK YOUR MATCH
          </h2>
          <p className="text-gray-500 mt-2 max-w-md mx-auto">
            Three distinct math disciplines, each with four progressive difficulty levels. Find your game.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {CHALLENGES.map(ch => (
            <div key={ch.type} className="group rounded-2xl overflow-hidden border border-gray-100 hover:border-green-200 transition-all">
              <div className="relative h-44 overflow-hidden">
                <img
                  src={ch.image}
                  alt={ch.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className={`absolute inset-0 bg-gradient-to-t ${ch.color} opacity-50`} />
                <div className="absolute top-3 left-3">
                  <span className={`text-xs font-bold px-2.5 py-1 rounded-full ${ch.tag}`}>
                    4 Levels
                  </span>
                </div>
                <div className="absolute bottom-3 left-3 w-10 h-10 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-xl">
                  <i className={`${ch.icon} text-white text-xl`} />
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-lg font-bold text-green-900 mb-1">{ch.title} Challenge</h3>
                <p className="text-sm text-gray-500 mb-4 leading-relaxed">{ch.desc}</p>
                <ul className="space-y-1 mb-4">
                  {ch.levels.map(l => (
                    <li key={l} className="text-xs text-gray-500 flex items-center gap-1.5">
                      <i className="ri-tennis-ball-fill text-lime-500 text-xs" />
                      {l}
                    </li>
                  ))}
                </ul>
                <Link
                  to={ch.path}
                  className="flex items-center justify-center gap-2 w-full py-2.5 rounded-xl bg-green-800 text-white text-sm font-semibold hover:bg-green-700 cursor-pointer transition-colors whitespace-nowrap"
                >
                  Play Now
                  <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
